import { render, staticRenderFns } from "./BaseDiscussionList.vue?vue&type=template&id=419b1dcc"
import script from "./BaseDiscussionList.vue?vue&type=script&lang=js"
export * from "./BaseDiscussionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419b1dcc')) {
      api.createRecord('419b1dcc', component.options)
    } else {
      api.reload('419b1dcc', component.options)
    }
    module.hot.accept("./BaseDiscussionList.vue?vue&type=template&id=419b1dcc", function () {
      api.rerender('419b1dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseDiscussionList.vue"
export default component.exports